// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MkAW+","left":"styles_left__ypof3","right":"styles_right__OGZ0-"};